var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.availability != 'OutOfStock' && !_vm.infiniteQty)?_c('div',[(_vm.qty == 1)?_c('span',[_vm._v(_vm._s(_vm._f("lang")('Última disponible!')))]):_c('span',[_vm._v(_vm._s(_vm._f("lang")('{qty} disponibles',{ qty: _vm.qty })))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }